// stripeClient.js
// ─────────────────────────────────────────────────────────────────────────────
// One shared Stripe.js instance for the account screens.
//
// loadStripe MUST be called at module scope — calling it inside a component
// re-downloads and re-initialises Stripe.js on every render. Both the saved-card
// form and the "Pay Now" retry need it, so it lives here rather than being
// duplicated (and drifting) in each.
//
// The key comes from the environment, never hardcoded, so a test build can't
// quietly take live payments or the reverse. A missing key resolves to null and
// each caller degrades on its own terms.
// ─────────────────────────────────────────────────────────────────────────────
import { loadStripe } from "@stripe/stripe-js";

export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";

export const stripePromise = STRIPE_PUBLISHABLE_KEY
  ? loadStripe(STRIPE_PUBLISHABLE_KEY)
  : null;

export default stripePromise;
